import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import i18n from 'src/i18n';
import ActionDrawer from 'src/components/ActionDrawer';
import ActionDrawerHeader from 'src/components/ActionDrawer/components/ActionDrawerHeader';
import FeeCollapse from 'src/components/FeeCollapse';
import FeeCollapseHeader from 'src/components/FeeCollapse/components/FeeCollapseHeader';
import FeeCollapseFooter from 'src/components/FeeCollapse/components/FeeCollapseFooter';
import styles from './styles.module.scss';

@observer
class RentalPriceDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.vm = props.vm;
  }

  render() {
    return (
      <ActionDrawer vm={this.vm.drawerVM} width={375} onClose={this.vm.close}>
        {this.vm.check.rental ? (
          <div className={styles.container}>
            <ActionDrawerHeader
              content={i18n.t('rental_price_drawer_header')}
              paddingBottom
            />

            <div className={styles.desc}>
              {i18n.t('rental_price_drawer_desc')}
            </div>

            <div className={styles.table}>
              <FeeCollapseHeader
                item1={i18n.t('rental_price_drawer_items_table_item_label')}
                item2={i18n.t('rental_price_drawer_items_table_price_label')}
              />

              {this.vm.items.map((item) => (
                <FeeCollapse data={item} key={item.key} />
              ))}

              <FeeCollapseFooter
                item1={i18n.t('rental_price_drawer_total_label')}
                item2={this.vm.total}
              />
            </div>
          </div>
        ) : null }
      </ActionDrawer>
    );
  }
}

RentalPriceDrawer.propTypes = {
  vm: PropTypes.object.isRequired
};

RentalPriceDrawer.defaultProps = {};

export default RentalPriceDrawer;
